import { useCallback, useEffect, useState } from 'react';
import { slackApi, SlackChannel } from '../api/slackApi';

export function useSlackChannels() {
	const [channels, setChannels] = useState<SlackChannel[]>([]);
	const [isLoading, setIsLoading] = useState(false);
	const [error, setError] = useState<string | null>(null);

	const fetchChannels = useCallback(async () => {
		setIsLoading(true);
		setError(null);

		try {
			const result = await slackApi.getChannels();
			setChannels(result.channels);
		} catch (err) {
			const errorMessage = err instanceof Error ? err.message : 'Failed to fetch channels';
			setError(errorMessage);
			setChannels([]);
		} finally {
			setIsLoading(false);
		}
	}, []);

	// Auto-fetch channels when hook is first used
	useEffect(() => {
		fetchChannels();
	}, [fetchChannels]);

	const refreshChannels = useCallback(() => {
		fetchChannels();
	}, [fetchChannels]);

	return {
		channels,
		isLoading,
		error,
		refreshChannels,
	};
}


